"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const sizes = {
    small: '12px',
    smallX: '14px',
    medium: '16px',
    mediumX: '18px',
    mediumXX: '20px',
    large: '24px',
    largeX: '32px',
    largeXX: '40px'
};
exports.default = sizes;
